import Vue from 'vue'

Vue.filter('highlight', (words, query) => {
  if (query) {
    var check = new RegExp(query.toLowerCase(), "ig");
    if (words) {
      return words.toString().replace(check, function (matchedText) {
        return '<span class="highlight">' + matchedText + "</span>";
      });
    } else {
      return words;
    }
  } else {
    return words;
  }
})
